type ContainerPageParams = {
	/**
	 * campaignId can be either the campaignId or the campaignName
	 */
	campaignId: string;
	productId: string;
};

export const buildContainerPageUrl = (BVParams: ContainerPageParams) => {
	const params = new URLSearchParams();

	params.append('bvaction', 'rr_submit_review');

	for (const param in BVParams) {
		if (BVParams[param]) {
			params.append(`bv${param}`, BVParams[param]);
		}
	}

	return `/product/reviews?${params.toString()}`;
};
